/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Form } from "antd";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import PictureView from "../../components/PictureView";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class PosImages extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _imageType: null,
            _posList: '',
            _fileName: null
        };

        if (props.data.IMAGE_TYPES_LIST === undefined) props.data.IMAGE_TYPES_LIST = { ...props.data.genericSelector };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21801);
    }

    onRemove = () => {
        const { _fileName } = this.state
        this.sendAPI("delete_pos_images", { _fileName }, () => {
            this.setState({ _fileName: "" })
        })
    }

    onChange = (v) => {
        const { _posList } = this.state
        this.sendAPI("save_pos_images", { _posList, _fileName: v }, () => {
            this.setState({ _fileName: v })
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            width: window.innerWidth <= 600 ? "100%" : 600,
            margin: "auto",
        };

        return (<div style={divStyle}>
            <PageToolbar title={gt(21801)} actionButtons={[]} />
            <Form.Item label={gt(21802)}>
                <GenericSelector
                    {...this.props}
                    id={"IMAGE_TYPES_LIST"}
                    api={"image_types_list"}
                    value={this.state._imageType}
                    onChange={e => { this.setState({ _imageType: e }) }}
                    filterList={["G","H","U"]}
                />
            </Form.Item>
            <Form.Item label={gt(21803)}>
                <GenericSelectorPosStorages
                    {...this.props}
                    multi
                    value={this.state._posList ? this.state._posList.split(",") : []}
                    onChange={e => { this.setState({ _posList: e ? e.join(",") : "" }) }}
                />
            </Form.Item>
            <Form.Item label={gt(21804)}>
                <PictureView
                    {...this.props}
                    imageType={this.state._imageType}
                    url={this.state._fileName}
                    onRemove={this.onRemove}
                    onChange={this.onChange}
                    disabled={!this.state._imageType || !this.state._posList}
                    onUploadedSuccess={() => { }} onUploadedFailed={() => { }}
                />
            </Form.Item>
        </div>)
    }

}

export default PosImages;